import React from "react";
import { Leaf, Flame, Timer, Users, Award, Sparkles, Star, Clock, MapPin, Smartphone, ShoppingBag, Sandwich, Building2, GraduationCap } from "lucide-react";
import { useSiteContent } from "../data/SiteContentContext";

const ICON_MAP = { Leaf, Flame, Timer, Users, Award, Sparkles, Star, Clock, MapPin, Smartphone, ShoppingBag, Sandwich, Building2, GraduationCap };

const DEFAULT_POINTS = [
  { icon: "Leaf", title: "Made Fresh Daily", desc: "We use quality ingredients and make everything fresh to order." },
  { icon: "Flame", title: "Real Flavor", desc: "Bold, authentic flavors in every bite. Nothing frozen, ever." },
  { icon: "Timer", title: "Fast Service", desc: "Great food, fast. Because your time matters." },
  { icon: "Users", title: "Built for the Community", desc: "Proudly serving Queens with love and respect." },
];

export default function WhyBTW() {
  const { content } = useSiteContent();
  const w = content?.why || {};
  const title = w.title || "Why BTW?";
  const points = (w.points && w.points.length ? w.points : DEFAULT_POINTS);

  return (
    <section
      id="why-btw"
      data-testid="why-btw-section"
      className="bg-[#0B0B0B] text-white py-12 sm:py-24"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="flex items-center justify-center sm:justify-start gap-3 mb-12">
          <span className="h-[2px] w-12" style={{ background: "#A3D900" }} />
          <h2 className="font-display text-4xl sm:text-5xl uppercase tracking-tight">
            {title}
          </h2>
          <span className="h-[2px] w-12 sm:hidden" style={{ background: "#A3D900" }} />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-9">
          {points.map((p) => {
            const Icon = ICON_MAP[p.icon] || Leaf;
            return (
              <div
                key={p.title}
                className="flex flex-col items-center text-center sm:items-start sm:text-left"
                data-testid={`why-btw-${p.title.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <span
                  className="inline-flex h-12 w-12 items-center justify-center rounded-full"
                  style={{ background: "rgba(163,217,0,0.12)", color: "#A3D900" }}
                >
                  <Icon size={24} />
                </span>
                <h3 className="mt-4 font-display text-xl uppercase tracking-wider">
                  {p.title}
                </h3>
                <p className="mt-2 text-white/70 text-sm leading-relaxed max-w-xs">
                  {p.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
